import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataTableModule } from 'angular2-datatable';
import { Ng2AutoCompleteModule } from 'ng2-auto-complete';

import { ModalComponent } from './modal.component';
import { DriverFormComponent } from './driverform/driverform.component';
import { DriverProfileComponent } from './driverprofile/driverprofile.component';
import { MyDatePickerModule } from 'mydatepicker';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BreadcrumbComponent } from './breadcrumb.component';
import { DriverNameComponent } from './driver-name/driver-name.component';
import { Router, ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET, RouterModule } from '@angular/router';
import { WorkChartComponent } from './work-chart/work-chart.component';
import { WorkFormCommonComponent } from './work-form-common/work-form-common.component';
import { WrittenWorkDiaryFormCommonComponent } from './written-work-diary-form-common/written-work-diary-form-common.component';
import { ChartsModule } from 'ng2-charts';
import { LaddaModule } from 'angular2-ladda';
import { LoadingModule } from 'ngx-loading';
import { TableModule } from 'primeng/table';

import { DataFilterPipe } from './pipes/datafilterpipe';
import { WorkLogCommonComponent } from './work-log-common/work-log-common.component';
import { TransferhistoryComponent } from './transferhistory/transferhistory.component';
import { DateRangeComponent } from './date-range/date-range.component';
import { DateSearchComponent } from './date-search/date-search.component';

@NgModule({
  imports: [
    CommonModule,
    DataTableModule,
    MyDatePickerModule,
    ReactiveFormsModule,
    FormsModule,
    RouterModule,
    ChartsModule,
    Ng2AutoCompleteModule,
    LaddaModule,
    TableModule
  ],
  declarations: [
    ModalComponent,
    DriverFormComponent,
    DriverProfileComponent,
    BreadcrumbComponent,
    DriverNameComponent,
    WorkChartComponent,
    WorkFormCommonComponent,
    WrittenWorkDiaryFormCommonComponent,
    DataFilterPipe,
    WorkLogCommonComponent,
    TransferhistoryComponent,
    DateRangeComponent,
    DateSearchComponent,
    ],
  exports: [
    ModalComponent,
    DriverFormComponent,
    DriverProfileComponent,
    BreadcrumbComponent,
    DriverNameComponent,
    WorkChartComponent,
    WorkFormCommonComponent,
    WrittenWorkDiaryFormCommonComponent,
    DataFilterPipe,
    WorkLogCommonComponent,
    TransferhistoryComponent,
    DateRangeComponent,
    DateSearchComponent,
    ]
})
export class SharedModule { }
